import create, { SetState, GetState } from 'zustand';

const stateDefault = {
  selected: null,
  result: {},
  page: 1,
  keywords: '',
  createModal: false,
};

const actions = (set, get) => ({
  setResult: (payload) => {
    set((state) => ({
      ...state,
      result: payload,
    }));
  },
  setSelected: (payload) => {
    set((state) => ({
      ...state,
      selected: payload,
    }));
  },
  setPage: (payload) => {
    set((state) => ({
      ...state,
      page: payload,
    }));
  },
  setKeywords: (payload) => {
    set((state) => ({
      ...state,
      keywords: payload,
    }));
  },
  setCreateModal: () => {
    set((state) => ({
      ...state,
      createModal: !state.createModal,
    }));
  },
});

export const useAcademicYear = create((set, get) => ({
  ...stateDefault,
  ...actions(set, get),
}));
